import { ActivityIcon } from '../Icon';
import type { ActivityType } from 'types';
import { HTMLAttributeAnchorTarget, ReactElement } from 'react';
import { TitleContainer } from 'components/TitleContainer';
import { Box } from '@ff-it/ui';
import { EnterpriseLink } from 'components/EnterpriseLink';

export interface BlockWidgetProps {
  id: number;
  code: string;
  title: string;
  campaign_id?: number;
  final_client_po_number: string | null;
  type: ActivityType;
  flat?: boolean;
}

export function BlockWidget({
  id,
  code,
  title,
  campaign_id,
  link,
  type,
  className,
  flat,
  target = '_blank',
}: BlockWidgetProps & { link?: boolean; target?: HTMLAttributeAnchorTarget; className?: string }): ReactElement {
  const content =
    link && campaign_id ? (
      <EnterpriseLink to={`/planning/campaigns/${campaign_id}/planning/${id}`} target={target}>
        {code}
      </EnterpriseLink>
    ) : (
      code
    );

  return (
    <TitleContainer
      testId={`block-${id}`}
      className={className}
      flat={flat}
      title={
        <Box display="flex">
          <ActivityIcon type={type} className="mr-1" /> {content}
        </Box>
      }
      subtitle={title || type}
    />
  );
}
